import { render, staticRenderFns } from "./Salario.vue?vue&type=template&id=25653a52&scoped=true&"
import script from "./Salario.vue?vue&type=script&lang=js&"
export * from "./Salario.vue?vue&type=script&lang=js&"
import style0 from "./Salario.vue?vue&type=style&index=0&id=25653a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25653a52",
  null
  
)

export default component.exports